module.exports = __webpack_public_path__ + "img/scrm-2.432f6409.png";